import React from 'react';
import PropTypes from 'prop-types';

import styles from './LoginBar.module.scss';
import Brand from 'assets/logo.png';
import { Input, Button } from 'components/Template';
import { faUser, faLock } from '@fortawesome/free-solid-svg-icons';

function LoginBar({
  email,
  password,
  inputChangeHandler,
  submitHandler,
  mobileLoginTrigger,
  authError,
}) {
  return (
    <header className={styles.loginBar}>
      <img draggable='false' src={Brand} alt='Logotipo SQM-Vitas' onClick={() => window.scrollTo({ top: 0, left: 0 })} className={styles.brand} />
      <form onSubmit={submitHandler} className={styles.formContainer}>
        <div
          onClick={() => mobileLoginTrigger(true)}
          className={styles.MobileLoginTrigger}
        >
          <p>Entrar</p>
        </div>
        <div className={styles.inputsRow}>
          <div className={styles.inputContainer}>
            <div className={styles.inputsRow}>
              <Input
                type='email'
                name='email'
                onChange={inputChangeHandler}
                containerClassName={styles.input}
                placeholder='E-mail'
                icon={faUser}
                value={email}
              />
              <Input
                name='password'
                onChange={inputChangeHandler}
                containerClassName={styles.input}
                placeholder='Senha'
                type='password'
                icon={faLock}
                value={password}
              />
            </div>
            <div className={styles.elementRow}>
              <p className={styles.error} style={{ display: !authError ? 'none' : 'block', color: 'red' }}>
                {authError}
              </p>
            </div>
            <div className={styles.inputsRow}>
              <p style={{ display: 'block' }}>
                NÃO TEM CADASTRO?
              </p>
              <p>
                ESQUECEU A SENHA?
              </p>
            </div>
          </div>
          <Button
            type={'submit'}
            color='success'
            onClick={submitHandler}
            className={styles.button}
          >
            Entrar
          </Button>
        </div>
      </form>
    </header>
  );
}

LoginBar.defaultProps = {
  authError: null,
};

LoginBar.propTypes = {
  email: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired,
  inputChangeHandler: PropTypes.func.isRequired,
  submitHandler: PropTypes.func.isRequired,
  mobileLoginTrigger: PropTypes.func.isRequired,
  authError: PropTypes.string,
};

export default LoginBar;
